<template>
	<view>
		<stepLine :active="0" :steps="steps" />
		<view class="base-message">
			<view class="message-item">
				<view class="label">运营者</view>
				<view class="message-value">
					<uni-easyinput
						:inputBorder="false"
						v-model="baseForm.realName"
						placeholderStyle="color:#ccc; font-size: 28rpx;"
						placeholder="请输入真实姓名" />
				</view>
			</view>
			<view class="message-item">
				<view class="label">性别</view>
				<view class="message-value" @click="$refs.sex.open(baseForm.sex)">
					<text :class="baseForm.sex?'':'un-select'">{{ baseForm.sex==1?'男':baseForm.sex==2?'女':'请选择' }}</text>
					<uni-icons type="right" size="22" color="#CCCCCC"></uni-icons>
				</view>
			</view>
			<view class="message-item">
				<view class="label">手机号</view>
				<view class="message-value" @click="selectSex">
					<uni-easyinput
						type="number"
						:inputBorder="false"
						v-model="authenticationForm.phone"
						placeholderStyle="color:#ccc; font-size: 28rpx;"
						placeholder="请输入手机号" />
				</view>
			</view>
			<view class="message-item">
				<view class="label">店铺名称</view>
				<view class="message-value">
					<uni-easyinput
						:inputBorder="false"
						v-model="baseForm.merchantName"
						placeholderStyle="color:#ccc; font-size: 28rpx;"
						placeholder="请输入店铺名称" />
				</view>
			</view>
			<view class="message-item">
				<view class="label">店铺位置</view>
				<view class="message-value" @click="select">
					<text :class="baseForm.area?'':'un-select'">{{ baseForm.area||'请选择' }}</text>
					<uni-icons type="right" size="22" color="#CCCCCC"></uni-icons>
				</view>
			</view>
			<view class="parting"></view>
			<view class="persnal-introduce">
				<view class="introduce-title">店铺简介和Logo</view>
				<view class="introduce-logo">
					<uni-easyinput
						:inputBorder="false"
						v-model="baseForm.nickName"
						:maxlength="500"
						autoHeight
						placeholder="描述店铺，有助于更快成为商家"
						type="textarea"
					/>
					<uni-file-picker limit="1">
						<view class="model">
							上传照片
						</view>
					</uni-file-picker>
				</view>
			</view>
		</view>
		<view class="next-btn" @click="nextStep">下一步</view>
		<view class="safe-area"></view>
		<SexSelect ref="sex" @updata="updataSex"/>
		<areaSelect ref="areaSelect" @updata="updateArea"/>
	</view>
</template>

<script>
	import stepLine from '@/components/common/stepLine.vue'
	import SexSelect from "@/components/common/sexSelect.vue"
	import areaSelect from "@/components/common/areaSelect.vue"
	export default {
		components: { stepLine, SexSelect, areaSelect },
		data() {
			return {
				steps: [
					{ title: '基本信息' },
					{ title: '资质认证' },
					{ title: '提交审核' }
				],
				baseForm: {
					realName: '',
					sex: '',
					
				}
			};
		},
		methods: {
			updataSex(v) {
				this.baseForm.sex=v
			},
			updateArea(v) {
				console.log(v);
			},
			select() {
				uni.navigateTo({
					url: '/pages/selectLocation/selectLocation'
				})
				
			},
			nextStep() {
				uni.navigateTo({
					url: '/pages/merchant/applyMerchant/certificationCofirm'
				})
			},
			
		}
	}
</script>

<style lang="scss" scoped>
.base-message {
	background-color: #FFFFFF;
	padding: 32rpx;
	.message-item {
		display: flex;
		justify-content: space-between;
		height: 96rpx;
		border-bottom: 2rpx solid #F4F5F4;
		.label {
			line-height: 96rpx;
			font-size: 28rpx;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			&::after {
				content: '*';
				color: #D20A0A;
			}
		}
		.message-value {
			flex: 1;
			text-align: right;
			line-height: 96rpx;
			margin: auto 0;
			font-size: 28rpx;
			.un-select {
				font-size: 28rpx;
				color: #CCCCCC;
			}
		}
	}
}
/deep/ .uni-easyinput__content-input {
	text-align: right;
	font-size: 28rpx !important;
}
.parting {
	background: #f7f7f7;
	height: 16rpx;
	width: 120%;
	margin-left:-33rpx;
}

.persnal-introduce {
	.introduce-title {
		font-size: 32rpx;
		font-family: PingFang SC-Semibold, PingFang SC;
		font-weight: 600;
		color: #333333;
		padding-top: 28rpx;
	}
	.introduce-logo {
		background: #f5f5f5;
		padding: 26rpx;
		margin: 28rpx 0;
		.model {
			width: 100%;
			height: 100%;
			// background-color: rgba(0, 0, 0, 0.35);
			border: 2rpx dashed rgba(153,153,153,0.35);
			border-radius: 8rpx;
			text-align: center;
			line-height: 100px;
			font-size: 28rpx;
			font-weight: 400;
			color: #999999;
			box-sizing: border-box;
		}
	}
}
.next-btn {
	height: 72rpx;
	margin: 126rpx 56rpx 0;
	background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
	border-radius: 36rpx 36rpx 36rpx 36rpx;
	color: #FFFFFF;
	line-height: 72rpx;
	text-align: center;
}
.safe-area {
	height: env(safe-area-inset-bottom);
	padding: 20rpx;
}
</style>
